import { createApp } from 'vue'
import {mapLocalizationData} from '../../../common/vue/helper/LocalizationMapper'
import ImageContentPluginForm from "./ImageContentPluginForm.vue";

document.addEventListener('DOMContentLoaded', () =>{
    let rootId = 'imagecontentpluginform';
    let rootElement = document.getElementById(rootId);

    if (rootElement) {
        let app = createApp(ImageContentPluginForm, {
                        editorName: rootElement.getAttribute('data-editor-name'),
                        loadFoldersUrl: rootElement.getAttribute('data-load-folders-url'),
                        loadFilesUrl: rootElement.getAttribute('data-load-files-url'),
                        formId: rootElement.getAttribute('data-form-id'),
                        formDefinitionJson: rootElement.getAttribute('data-form-definition-json'),
                        csrfToken: rootElement.getAttribute('data-csrf-token'),
                        i18n: mapLocalizationData(rootElement),
            }
        );
        app.mount(rootElement);
    }

});
